export default __webpack_public_path__ + "static/media/376.7d8c819e.jpg";